import { FETCH_ALL_PUTT_GOLF_STATS, FETCH_ALL_PUTT_GOLF_STATS_SUCCESS } from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    payload: {}
};

const fetchAllPuttGolfStatsSuccess = (state, action) => {
    return {
        isFetching: false,
        payload: action.puttGolfStats
    };
};

const handlers = {
    [FETCH_ALL_PUTT_GOLF_STATS_SUCCESS]: fetchAllPuttGolfStatsSuccess
};

export default function puttGolfStats(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchAllPuttGolfStats() {
    return {
        type: FETCH_ALL_PUTT_GOLF_STATS,
        isFetching: true
    };
}

export const getPuttGolfStats = (state) => {
    return state.puttGolfStats;
};
